import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-how-works',
  templateUrl: './how-works.component.html',
  styleUrl: './how-works.component.scss'
})
export class HowWorksComponent implements OnInit {
  @Input() giPantMode: boolean = false;
  @Input() henterPantMode: boolean = false;

  constructor() {
  }

  ngOnInit(): void {
  }
}
